import { Box, Typography } from "@mui/material";

export default function DunsSummary(){
  return (
    <Box>
      <Typography variant="body1">
        Solicite um número DUNS para sua empresa, obrigatório para criar o seu cadastro de desenvolvedor no Google Play.
      </Typography>
    </Box>
  )
}